import './aggregatorAcceptConsentStep.scss';

// @ vendor
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// @ components
import { OKButton } from 'commonsComponents/OKButton';
import { OKLink } from 'commonsComponents/OKLink';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import OKModal from 'commonsComponents/OKModal';
import Storage from 'utilities/storage';
const { formatText } = require('core/i18n').i18n;

// @constants
import { SELECTED_BANK, PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';
import { RENEW_CONSENT, CREATE_CONSENT, } from 'constants/aggregator/psd2DecoupledFlowType';

const {
    recordPath,
    recordLink,
    PROC_AGGREGATOR,
    PROC_AGGREGATOR_CONSENT_FIRST_STEP,
    PROC_AGGREGATOR_CONSENT,
    PROC_AGGREGATOR_CONSENT_FIRST_STEP_GO_TO,
    PROC_FIRST_STEP,
    PROC_AGGREGATOR_RENEW_CONSENT,
    PROC_AGGREGATOR_RENEW_CONSENT_1,
    PROC_AGGREGATOR_RENEW_CONSENT_GO_TO,
} = require('utilities/tagging');

// @ actions
import { requestConsentsUrl, initStoreConsentsPSD2 } from 'actions/aggregator/aggregatorConsentsPSD2';

class AggregatorAcceptConsentStep extends React.Component {
    constructor() {
        super();
        const { bankName, bankLogo, userBankId } = Storage.localStorage.get(SELECTED_BANK) || {};
        const psd2FlowType = Storage.localStorage.get(PSD2_FLOW_TYPE) || '';
        this.state = { bankName, bankLogo, userBankId, psd2FlowType }
    }

    componentDidMount() {
        const { psd2FlowType } = this.state;
        this.props.requestConsentsUrl(this.state.userBankId);

        if (psd2FlowType === CREATE_CONSENT) {
            recordPath(PROC_AGGREGATOR_CONSENT_FIRST_STEP, null, PROC_AGGREGATOR_CONSENT, PROC_FIRST_STEP);
        } else if (psd2FlowType === RENEW_CONSENT) {
            recordPath(PROC_AGGREGATOR_RENEW_CONSENT_1, null, PROC_AGGREGATOR_RENEW_CONSENT, PROC_FIRST_STEP);
        }
    }

    saveConsentID = () => {
        const { bankName, psd2FlowType } = this.state;

        if (psd2FlowType === CREATE_CONSENT) {
            recordLink(PROC_AGGREGATOR, `${PROC_AGGREGATOR_CONSENT_FIRST_STEP_GO_TO} ${bankName}`);
        } else if (psd2FlowType === RENEW_CONSENT) {
            recordLink(PROC_AGGREGATOR, `${PROC_AGGREGATOR_RENEW_CONSENT_GO_TO} ${bankName}`);
        }

        const storageContent = Storage.localStorage ? Storage.localStorage.get(SELECTED_BANK) : {};
        const newSelectedBank = {
            ...storageContent,
            consentId: this.props.consentId
        };
        Storage.localStorage.set(SELECTED_BANK, newSelectedBank);
    }

    handlePrimaryButtonClick= () => {
        this.props.initStoreConsentsPSD2();
        this.props.requestConsentsUrl(this.state.userBankId);
    }

    handleModalCloseButtonClick = () => {
        this.props.initStoreConsentsPSD2();
        this.props.history.push(`/myprofile/global`)
    }

    render() {
        const {bankName, bankLogo, psd2FlowType}= this.state;
        const { redirectionUrl, errorURL, initStoreConsentsPSD2 } = this.props;

        const isCreateFlow = psd2FlowType === CREATE_CONSENT;
        const titleText = isCreateFlow? 'aggregatorPSD2-consentStepTitle' : 'aggregatorPSD2-renewConsentStepTitle';
        const mainText = isCreateFlow? 'aggregatorPSD2-consentStepMainText' : 'aggregatorPSD2-renewConsentStepMainText';
        const secondaryText = isCreateFlow? 'aggregatorPSD2-consentStepSecondaryText' : 'aggregatorPSD2-renewConsentStepSecondaryText';

        return (
            <React.Fragment>
                <OKSectionBox className="col-md-8" title={formatText(titleText, [bankName])} titleSeparator>
                    <p>{formatText(mainText)}</p>
                    <p>{formatText(secondaryText, [bankName])}</p>
                    <img className="aggregator-accept-consent-step__logo" src={bankLogo} />
                    <div className="aggregator-accept-consent-step__buttons">
                        <OKLink modifier="dark" onClick={() => initStoreConsentsPSD2()} isOKLinkOld={true} to={"/myprofile/global"} >{formatText('aggregatorPSD2-consentStepCancelButton')}</OKLink>
                        <OKButton loading={!redirectionUrl} onClick={()=> this.saveConsentID()} to={redirectionUrl} targetBlank={false}>{formatText('aggregatorPSD2-consentStepAcceptButton', [bankName])}</OKButton>
                    </div>
                </OKSectionBox>
                <OKModal
                    isOpen={errorURL}
                    title={formatText('aggregatorPSD2-redirectionUrlErrorTitle')}
                    content={formatText('aggregatorPSD2-redirectionUrlErrorMessage')}
                    footerType="action"
                    primaryButtonText={formatText('aggregatorPSD2-redirectionUrlErrorButton')}
                    onPrimaryButtonClick={this.handlePrimaryButtonClick}
                    onCloseCallback={() => this.handleModalCloseButtonClick()}
                />
            </React.Fragment>
        );
    }
}

AggregatorAcceptConsentStep.propTypes = {
    isFetching: PropTypes.bool,
    consentId: PropTypes.string,
    initStoreConsentsPSD2: PropTypes.func.isRequired,
    redirectionUrl: PropTypes.string,
    errorURL: PropTypes.object,
    history: PropTypes.object.isRequired,
    requestConsentsUrl: PropTypes.func.isRequired,
    scrapingCredentials: PropTypes.bool,
    userBankId: PropTypes.string,
}

export default connect(state => ({
    isFetching:  state.aggregatorConsentsPSD2.get('isFetchingUrl'),
    consentId: state.aggregatorConsentsPSD2.get('consentId'),
    redirectionUrl: state.aggregatorConsentsPSD2.get('redirectionUrl'),
    errorURL: state.aggregatorConsentsPSD2.get('errorURL'),
    scrapingCredentials: state.aggregatorConsentsPSD2.get('scrapingCredentials'),
}),{
    requestConsentsUrl,
    initStoreConsentsPSD2,
})(withRouter(AggregatorAcceptConsentStep));
